import { Divider, Row } from 'antd'
import { FC } from 'react'

import { BitazzaText } from '../../../../components'
import { Reward } from './Reward'
import Styles from './Rewards.module.scss'
import { useTranslation } from 'react-i18next'

interface Props {
    rewards?: prizeSeasonStatus[]
    bigSize?: boolean
    seasonName?: string
    userRank?: number | null
}
export const Rewards: FC<Props> = ({
    rewards,
    bigSize,
    seasonName,
    userRank,
}) => {
    const { t } = useTranslation()
    return (
        <div className={Styles.container}>
            <BitazzaText
                content="REWARDS"
                color="#FFFF"
                letterSpacing={2}
                format="t20"
            />
            <Divider className={Styles.dividerText} />
            <Row justify="center">
                {rewards && rewards.length ? (
                    rewards.map((rew: prizeSeasonStatus, index) => {
                        if (rew.detail.nft_type !== 'Medal') {
                            return (
                                <Reward
                                    bigSize={bigSize}
                                    key={index}
                                    img={rew.detail.image_url}
                                    total={rew.type ? null : rew.amount}
                                    textColor="#D4B578"
                                    nft_type={rew.detail.nft_name}
                                />
                            )
                        }
                    })
                ) : (
                    <BitazzaText
                        textAlign="center"
                        content={
                            userRank
                                ? 'You are not eligible for rewards since your account has not been verified.'
                                : `${t(
                                      'txt_no_rewards_this_season'
                                  )} ${seasonName}`
                        }
                        color="#86A1A1"
                        bold
                        lineHeight={18}
                        letterSpacing={1}
                    />
                )}
            </Row>
        </div>
    )
}
